import React from 'react';
import { Box } from '@mui/material';
import { ToastContainer } from 'react-toastify';

import CustomDropdownTable from './CustomDropdownTable';
import useStyles from './styles';

const PlaylistConfigTableView = ({
	playlistConfigMode,
	pageLevelConfig,
	handlePlaylistConfigSinglePageSync,
	handlePlaylistConfigBulkPageSync,
	siteId,
	setPlaylistConfigMode,
	setPlaylistConfigPage
}) => {
	const classes = useStyles();
	const contentRows = pageLevelConfig.map((page) => ({
		url: page.pageUrl,
		activeVideos: page.videos.length,
		videos: page.videos
	}));

	return (
		<Box className={classes.tableWrapper}>
			<CustomDropdownTable
				playlistConfigMode={playlistConfigMode}
				headRow={['Page Path', 'Active Videos', 'Sync', 'CDN Url', 'Edit']}
				siteId={siteId}
				contentRows={contentRows}
				handlePlaylistConfigSinglePageSync={handlePlaylistConfigSinglePageSync}
				handlePlaylistConfigBulkPageSync={handlePlaylistConfigBulkPageSync}
				setPlaylistConfigMode={setPlaylistConfigMode}
				setPlaylistConfigPage={setPlaylistConfigPage}
			/>
			<ToastContainer />
		</Box>
	);
};

export default PlaylistConfigTableView;
